import {ApplicationEntityType, AvailableApplicationResult} from '@linx-security/api-specs';

export const calcApplicationEntityType = (app: unknown) =>
  (app as AvailableApplicationResult)?.application_entity_type ?? ApplicationEntityType.Application;

export const isMcpOrAiApplication = (entityType?: ApplicationEntityType | null) =>
  entityType === ApplicationEntityType.McpServer || entityType === ApplicationEntityType.AiApplication;
